const iconNames = {
  fileText: 'file-text-o',
  inbox: 'inbox',
  eye: 'eye',
  calendar: 'calendar-check-o',
  archive: 'archive',
  pencil: 'pencil',
  areaChart: 'area-chart',
  plusCircle: 'plus-circle',
  arrowCircleORight: 'arrow-circle-o-right',
  exchange: 'exchange',
  angleRight: 'angle-right',
  angleDoubleRight: 'angle-double-right',
  plus: 'plus',
  repeat: 'files-o',
  trashO: 'trash-o',
  chevronRight: 'chevron-right',
  refresh: 'refresh',
  questionCirle: 'question-circle',
  deleted: 'trash',
  userLock: 'user-lock'

};
const headerManaging = 'MANAGING';
const headerDropdownTextDefault = 'CHOOSE CLIENT';
const iconHomeForManager = '/manager/dashboard';
const iconHomeForUser = '/manager-dashboard'; // '/user/dashboard';
const userRole = 'User';
const emRole = 'Event Manager';
const amRole = 'Account Manager';
const listOptionPrefMonth = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUL',
  'JUN',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC'
];

const eventStatus = {
  drafts: 'drafts',
  submitted: 'submitted',
  review: 'review',
  approved: 'approved',
  archived: 'archived',
  deleted: 'deleted'
};

const modalAction = {
  saveEvent: 'saveEvent',
  submitEvent: 'submitEvent',
  approveEvent: 'approveEvent',
  suggestChanges: 'suggestChanges',
  reviewSuggestChanges: 'reviewSuggestChanges',
  reviewResubmit: 'reviewResubmit',
  changeOrder: 'changeOrder',
  changeOrderDetail: 'changeOrderDetail',
  deleteEvent: 'deleteEvent',
  showInfo: 'showInfo',
  submitAllEventError: 'submitAllEventError',
  eventPrefDateInvalid: 'eventPrefDateInvalid',
  eventNameNotUnique: 'eventNameNotUnique',
  someFieldsBlank: 'someFieldsBlank',
  lessThan90Days: 'lessThan90Days',
  someEmptyFields: 'someEmptyFields',
  someEmptyFieldsOrLessThan90Days: 'someEmptyFieldsOrLessThan90Days',
  submitAllError: 'submitAllError',
  eventDurationRestricted: 'eventDurationRestricted',
  addClient: 'addClient',
  createUser: 'createUser',
  editUser: 'editUser',
  createValidator: 'createValidator',
  createStaff: 'createStaff',
  editValidator: 'editValidator',
  readOnly: 'readOnly',
  resetPassword: 'resetPassword',
  moveEvent: 'moveEvent',
  emailMustBeAValid: 'emailMustBeAValid',
  editEvent: 'editEvent',
  deleteUser: 'deleteUser',
  deleteValidator: 'deleteValidator',
  forceUserResetPassword: 'forceUserResetPassword',
  modalManageRelatedEvents: 'modalManageRelatedEvents',
  modalAlertChangeEmailTemplate: 'modalAlertChangeEmailTemplate',
  modalCancelEmail: 'modalCancelEmail',
  emailIsNotValid: 'emailIsNotValid',
  deleteClient: 'deleteClient'
};

const EVENT_TYPES = {
  eventManager: {
    magagerOverview: {
      text: eventStatus.eventManager,
      btnRight: 'Go to event',
      btnRightIcon: '',
      btnLeft: '',
      lastUpdateText: 'updated',
      action: modalAction.saveEvent
    }
  },
  drafts: {
    text: eventStatus.drafts,
    btnRight: 'save event',
    btnRightIcon: iconNames.fileText,
    btnLeft: '',
    lastUpdateText: 'updated',
    action: modalAction.saveEvent
  },
  submitted: {
    approve: {
      text: eventStatus.submitted,
      btnRight: 'Review for approval',
      btnRightRelated: 'Approve event',
      btnRightIcon: iconNames.angleRight,
      btnLeft: 'cancel',
      lastUpdateText: 'submitted',
      action: modalAction.approveEvent
    },
    suggestChanges: {
      text: eventStatus.submitted,
      btnRight: 'suggest changes',
      btnRightIcon: iconNames.exchange,
      btnLeft: '',
      lastUpdateText: 'submitted',
      action: modalAction.suggestChanges
    }
  },
  review: {
    suggestChanges: {
      text: eventStatus.submitted,
      btnRight: 'suggest changes',
      btnRightIcon: iconNames.exchange,
      btnLeft: 'cancel',
      lastUpdateText: 'submitted',
      action: modalAction.reviewSuggestChanges
    },
    resubmit: {
      text: eventStatus.submitted,
      btnRight: 'Resubmit',
      btnRightIcon: iconNames.angleRight,
      btnLeft: 'cancel',
      lastUpdateText: 'submitted',
      action: modalAction.reviewResubmit
    }
  },
  approved: {
    text: eventStatus.review,
    funcBtnText: '',
    funcBtnIcon: '',
    isShowFuncBtn: false,
    lastUpdateText: 'approved'
  },
  archived: {
    text: eventStatus.archived,
    funcBtnText: '',
    funcBtnIcon: '',
    isShowFuncBtn: false,
    lastUpdateText: 'archived'
  },
  changeOrderDetail: {
    text: eventStatus.submitted,
    btnRight: 'Request Change',
    btnRightIcon: '',
    btnLeft: '',
    lastUpdateText: 'submitted',
    action: modalAction.changeOrderDetail
  },
  editEventAdmin: {
    text: eventStatus.submitted,
    btnRight: 'Save',
    btnRightIcon: '',
    btnLeft: 'Cancel',
    lastUpdateText: 'updated',
    action: modalAction.editEvent
  }
};

const USER_ROLE = {
  client: 'CLIENT',
  accountManager: 'ACCOUNT_MANAGER',
  eventManager: 'EVENT_MANAGER',
  clientManager: 'CLIENT_MANAGER',
  secondaryAccountManager: 'SECONDARY_ACCOUNT_MANAGER',
  admin: 'ADMIN',
  staff: 'STAFF',
  unknown: 'UNKNOWN'
};

const LOCAL_STORE = {
  token: 'sof_token',
  userId: 'sof_userId',
  role: 'sof_role',
  userName: 'sof_userName',
  clientId: 'sof_clientId',
  clientName: 'sof_clientName',
  pagingOptions: 'sof_pagingOptions',
  googleAPIKey: 'sof_google_api_key',
  addOns: 'sof_add_ons',
  readOnly: 'sof_read_only',
  isForceResetPassword: 'sof_is_force_reset_password',
  isBingMap: 'ems_is_use_bing',
  isShiftboardEnabled: 'is_shiftboard_enabled',
  searchEventString: 'search_event_string',
  sortEventString: 'sort_event_string',
  filterEventString: 'filter_event_string',
  dateRangeEvent: 'date_range_event'
};

const modalTypes = {
  changeSubmmitted: 'ChangeSubmitted',
  submitForApproval: 'SubmitForApprove',
  suggestChanges: 'SuggestChanges',
  approveEvent: 'ApproveEvent',
  changeOrder: 'ChangeOrder'
};

const sideBarItemNames = {
  dashboard: 'Dashboard',
  newEvent: 'New Event',
  draft: 'Drafts',
  submitted: 'Submitted to ',
  review: 'Needs review by ',
  approved: 'Approved',
  archived: 'Archived',
  events: 'Events',
  overview: 'Overview',
  deleted: 'Deleted'
};

const subHeaderBtn = {
  createNewEvent: {
    iconName: iconNames.plus,
    name: 'CreateEvent',
    btnText: 'New Event'
  },
  submitAllEvent: {
    iconName: iconNames.angleDoubleRight,
    name: 'SubmitAllEvent',
    btnText: 'Submit All Event'
  },
  addUser: {
    iconName: iconNames.plus,
    name: 'AddUser',
    btnText: 'Add User'
  },
  addValidator: {
    iconName: iconNames.plus,
    name: 'AddValidator',
    btnText: 'Add'
  },
  addStaff: {
    iconName: iconNames.plus,
    name: 'AddStaff',
    btnText: 'Add'
  }
};

const mappingModalActionToModalData = {
  submitEvent: {
    title: 'SUBMIT EVENT FOR APPROVAL',
    modalAction: modalAction.submitEvent,
    btnRight: 'SUBMIT',
    btnLeft: 'CANCEL',
    height: 370
  },
  approveEvent: {
    title: 'APPROVE EVENT',
    modalAction: modalAction.approveEvent,
    btnRight: 'APPROVE',
    btnLeft: 'CANCEL',
    height: 310
  },
  suggestChanges: {
    title: 'Suggest changes',
    modalAction: modalAction.suggestChanges,
    btnRight: 'CONTINUE',
    btnLeft: 'CANCEL',
    height: 310
  },
  reviewSuggestChanges: {
    title: 'Suggest changes',
    modalAction: modalAction.reviewSuggestChanges,
    btnRight: 'CONTINUE',
    btnLeft: 'CANCEL',
    height: 310
  },
  reviewResubmit: {
    title: 'Submit Event',
    modalAction: modalAction.reviewResubmit,
    btnRight: 'CONTINUE',
    btnLeft: 'CANCEL',
    height: 310
  },
  changeOrder: {
    title: 'Change Order',
    modalAction: modalAction.changeOrder,
    btnRight: 'CONTINUE',
    btnLeft: 'CANCEL',
    height: 400
  },
  changeOrderDetail: {
    title: 'Change Order',
    modalAction: modalAction.changeOrderDetail,
    btnRight: 'Request Change',
    btnLeft: '',
    height: 600
  },
  deleteEvent: {
    title: 'Delete Event',
    modalAction: modalAction.deleteEvent,
    btnRight: 'Delete Event',
    btnLeft: 'Cancel',
    height: 290
  },
  showInfo: {
    title: 'Changes submitted',
    modalAction: modalAction.showInfo,
    btnRight: 'DONE',
    btnLeft: '',
    height: 310
  },
  submitAllEventError: {
    title: 'Warning',
    modalAction: modalAction.submitAllEventError,
    btnRight: 'DONE',
    btnLeft: '',
    height: 310
  },
  eventPrefDateInvalid: {
    title: 'Warning',
    modalAction: modalAction.eventPrefDateInvalid,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  emailIsNotValid: {
    title: 'Warning',
    modalAction: modalAction.emailIsNotValid,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  eventNameNotUnique: {
    title: 'Warning',
    modalAction: modalAction.eventNameNotUnique,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  someFieldsBlank: {
    title: 'Warning',
    modalAction: modalAction.someFieldsBlank,
    btnRight: 'OK',
    btnLeft: '',
    height: 290
  },
  lessThan90Days: {
    title: 'Warning',
    modalAction: modalAction.lessThan90Days,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  someEmptyFields: {
    title: 'Warning',
    modalAction: modalAction.someEmptyFields,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  someEmptyFieldsOrLessThan90Days: {
    title: 'Warning',
    modalAction: modalAction.someEmptyFieldsOrLessThan90Days,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  submitAllError: {
    title: 'Warning',
    modalAction: modalAction.submitAllError,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  eventDurationRestricted: {
    title: 'Warning',
    modalAction: modalAction.eventDurationRestricted,
    btnRight: 'OK',
    btnLeft: '',
    height: 310
  },
  addClient: {
    title: 'Add New Client',
    modalAction: modalAction.addClient,
    btnRight: 'Add Client',
    btnLeft: 'Cancel',
    height: 570
  },
  resetPassword: {
    title: 'Change password',
    modalAction: modalAction.resetPassword,
    btnRight: 'Continue',
    btnLeft: 'Cancel',
    height: 570
  },
  createUser: {
    title: 'Add New User',
    modalAction: modalAction.createUser,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  editUser: {
    title: 'Edit User',
    modalAction: modalAction.editUser,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  createValidator: {
    title: 'Add New Validator',
    modalAction: modalAction.createValidator,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  editValidator: {
    title: 'Edit Validator',
    modalAction: modalAction.editValidator,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  createStaff: {
    title: 'Add New Staff',
    modalAction: modalAction.createStaff,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 570
  },
  readOnly: {
    title: 'Warning',
    modalAction: modalAction.readOnly,
    btnRight: 'OK',
    btnLeft: '',
    height: 290
  },
  moveEvent: {
    title: 'Move Event',
    modalAction: modalAction.moveEvent,
    btnRight: 'Continue',
    btnLeft: 'Cancel',
    height: 290
  },
  emailMustBeAValid: {
    title: 'Warning',
    modalAction: modalAction.emailMustBeAValid,
    btnRight: 'OK',
    btnLeft: '',
    height: 290
  },
  editEvent: {
    title: 'Edit Event',
    modalAction: modalAction.editEvent,
    btnRight: 'Save',
    btnLeft: 'Cancel',
    height: 600
  },
  deleteUser: {
    title: 'Delete User',
    modalAction: modalAction.deleteUser,
    btnRight: 'Yes',
    btnLeft: 'No',
    height: 290
  },
  deleteValidator: {
    title: 'Delete Validator',
    modalAction: modalAction.deleteValidator,
    btnRight: 'Yes',
    btnLeft: 'No',
    height: 290
  },
  forceUserResetPassword: {
    title: 'Force Reset Password',
    modalAction: modalAction.forceUserResetPassword,
    btnRight: 'Yes',
    btnLeft: 'No',
    height: 300
  },
  modalManageRelatedEvents: {
    title: 'Manage Releted Events',
    modalAction: modalAction.modalManageRelatedEvents,
    btnRight: 'Yes',
    btnLeft: 'No',
    height: 570
  },
  modalAlertChangeEmailTemplate: {
    title: 'CHANGE TEMPLATE',
    modalAction: modalAction.modalAlertChangeEmailTemplate,
    btnRight: 'CHANGE TEMPLATE',
    btnLeft: 'Cancel',
    height: 300
  },
  modalCancelEmail: {
    title: 'CANCEL EMAIL',
    modalAction: modalAction.modalCancelEmail,
    btnRight: 'CANCEL EMAIL',
    btnLeft: 'KEEP EDITING',
    height: 300
  },
  deleteClient: {
    title: 'DELETE CLIENT',
    modalAction: modalAction.deleteClient,
    btnRight: 'DELETE',
    btnLeft: 'CANCEL',
    height: 300
  }
};

const routeDirect = {
  managerDashboard: '/manager/dashboard',
  managerEvents: '/manager/events',
  userDrafts: '/user/drafts',
  userDashboard: '/user/dashboard',
  userSubmitted: '/user/submitted',
  userRelatedEvent: '/user/relatedEvents',
  clientDashboard: '/manager-dashboard/dashboard',
  mfaEnterCode: '/login/mfa'
};

const listAPI = {
  client: {
    getClients: '/api/clients'
  }
};

const dataTableViewModes = {
  manager: 'Manager',
  client: 'Client',
  relatedEvents: 'RelatedEvent',
  modal: 'Modal'
};

const fields = {
  event: {
    id: 'id',
    eventName: 'eventName',
    prefDate: 'prefDate',
    projPart: 'projPart',
    fullAddress: 'fullAddress',
    eventLocation: 'eventLocation',
    startTime: 'startTime',
    endTime: 'endTime',
    timeZone: 'timeZone',
    duration: 'duration',
    contactName: 'contactName',
    email: 'email',
    phone: 'phone',
    customEventNote: 'customEventNote',
    additionalComments: 'additionalComments',
    status: 'status',
    shippingAddress: 'shippingAddress',
    index: 'index',
    clientId: 'clientId',
    createdBy: 'createdBy',
    lastModifiedBy: 'lastModifiedBy',
    timeStartModel: 'timeStartModel',
    contact: 'contact',
    showCollapse: 'showCollapse',
    userManualFilled: 'userManualFilled',
    durationBackup: 'durationBackup',
    shippingAddressBackup: 'shippingAddressBackup',
    eventNameBackup: 'eventNameBackup',
    additionalServices: 'additionalServices'
  }
};

const siteKey = '6LfuaDgUAAAAAPwpgrR-L_rns8N6zsxrymaTnZIg';

const sofMessages = {
  insertFieldBlank: '',
  submitAllEventSuccess: 'Submit all events successful'
};

const instructions = {
  duplicated: 'Duplicate',
  delete: 'Delete',
  submit: 'Submit',
  restoreToDrafts: 'Restore to Drafts',
  edit: 'Edit',
  forceResetPassword: 'Force reset password',
  prefDate: 'Format: XX/XX/XXXX\nPlease use leading zeros',
  startTime: 'Format: XX:XX AM/PM\nPlease use leading zeros'
};

const dateTimeFotmat = {
  usFormat: 'MM-DD-YYYY'
};

const messageErrors = {
  notUniqueName: 'Event name is not unique.',
  someEmptyFields: 'Some fields are empty.',
  lessThan90Days: 'Date must be over 90 days',
  someEmptyFieldsOrLessThan90Days: 'Some fields are empty or Date must be over 90 days',
  emailIsDuplicated: 'Email is existed.',
  userDeleted: 'Your account is disabled'
};

const modalBodies = {
  eventNameNotUnique: [
    'Event name is not unique.'
  ],
  someFieldsBlank: [
    'Please enter blank fields.'
  ],
  emailIsNotValid: [
    'Contact email is not valid.'
  ],
  eventDurationRestricted: ['Standard events can only be submitted with durations between 4 - 8 hours.', 'To request an event outside of this range please contact ADURO'],
  INVALID_DURATION: [
    'Standard events can only be submitted with durations between 4 - 8 hours. To request an event outside of this range please contact ADURO.'],
  IS_EMPTY: ['Incomplete information. Please fill in required information and continue submitting.'],
  INVALID_DATE: ['Events requested within 90 days. Normal event scheduling requires advanced notice of 90 days. Please choose dates that meet these requirements or contact ADURO for assistance.'],
  readOnly: ['You are not authorized to submit events, please contact your ADURO Event Manager for assistance.'],
  emailMustBeAValid: [
    'The email field must be a valid email.'
  ],
  deleteUser: ['Are you sure you want to delete this user?'],
  deleteClient: ['Are you sure you want to delete client {clientName}?', 'Page will be reload after delete.'],
  deleteValidator: ['Are you sure you want to delete this validator?'],
  modalAlertChangeEmailTemplate: ['Changing your email template will erase any changs you have made. Are you sure you want to change your email template?'],
  modalCancelEmail: ['Canceling the creation of this email will erase any changes you have made. Are you sure you want to cancel?']
};

const defaultModalMessage = {
  submissionMessage: '<p>By submitting this event to ADURO you are agreeing all of the information is accurate and if approved, ADURO will schedule the event.</p><br/><p>If the event is not approved, ADURO will send the event with changes or suggestions back to you.</p>',
  changeOrderMessage: '<p>Upon submitting, you agree:</p><ul><li>To accept your request to change the event must go through approval again</li><li>That we cannot guarantee your event will be approved for your requested change</li><li>To pay the fee associated with your contract with ADURO (review for details)</li></ul><p><br></p><p>Continuing to the next screen to change your event will NOT charge you.</p><p><br></p><p>Submitting your changes will.</p>'
};

let addOns = [
  {
    key: 'venipuncture',
    text: 'Venipuncture',
    value: false,
    isShow: false
  },
  {
    key: 'smallSiteConcierge',
    text: 'Micro Site Concierge',
    value: false,
    isShow: false
  },
  {
    key: 'cotinine',
    text: 'Cotinine',
    value: false,
    isShow: false
  },
  {
    key: 'paperScheduler',
    text: 'Paper Scheduler',
    value: false,
    isShow: false
  },
  {
    key: 'wbaStation',
    text: 'WBA Station',
    value: false,
    isShow: false
  },
  {
    key: 'smallSiteModel',
    text: 'Micro Site Model',
    value: false,
    isShow: false
  },
  {
    key: 'tobaccoSelfAttestation',
    text: 'Tobacco Self Attestation',
    value: false,
    isShow: false
  },
  {
    key: 'fluShots',
    text: 'Flu Shots',
    value: false,
    isShow: false
  },
  {
    key: 'covidVaccine',
    text: 'Covid Vaccine',
    value: false,
    isShow: false
  },
  {
    key: 'covidFluShots',
    text: 'Covid & Flu Shots',
    value: false,
    isShow: false
  }
];

const initEvent = {
  id: 0,
  eventName: 'New Event',
  prefDate: '',
  projPart: null,
  fullAddress: '',
  building: '',
  eventLocation: '',
  startTime: '',
  endTime: '',
  timeZone: '',
  duration: 0,
  contactName: '',
  email: '',
  phone: '',
  customEventNote: '',
  additionalComments: '',
  status: eventStatus.drafts.toUpperCase(),
  shippingAddress: '',
  index: 0,
  clientId: 0,
  createdBy: 0,
  lastModifiedBy: 0,
  timeStartModel: '',
  contact: [],
  showCollapse: true,
  userManualFilled: '',
  eventNameBackup: 'New Event',
  addOns: '',
  addOnsView: addOns,
  fluShot: 0,
  isOnlineScheduler: true,
  isChangeOrder: false,
  maxAppointmentPerslot: 0,
  maxStaffConcierge: 0,
  maxStaffLead: null,
  maxStaffScreener: 0,
  relatedEvents: [],
  shippingAddressBackup: '',
  startTime12HourString: '',
  additionalServices: [],
  isLive: true
};

const listAdditionalServicesKey = {
  venipuncture: 'venipuncture',
  smallSiteConcierge: 'smallSiteConcierge',
  cotinine: 'cotinine',
  paperScheduler: 'paperScheduler',
  wbaStation: 'wbaStation',
  smallSiteModel: 'smallSiteModel',
  tobaccoSelfAttestation: 'tobaccoSelfAttestation',
  fluShots: 'fluShots',
  covidVaccine: 'covidVaccine',
  covidFluShots: 'covidFluShots'
};

const mappingKeyToTextAdditionalServices = function (key) {
  if (key) {
    let mapping = {};
    mapping[listAdditionalServicesKey.venipuncture] = 'Venipuncture';
    mapping[listAdditionalServicesKey.fluShots] = 'Flu Shots';
    mapping[listAdditionalServicesKey.smallSiteConcierge] = 'Small Site Concierge';
    mapping[listAdditionalServicesKey.cotinine] = 'Cotinine';
    mapping[listAdditionalServicesKey.paperScheduler] = 'Paper Scheduler';
    mapping[listAdditionalServicesKey.kioskModel] = 'Kiosk Model';
    mapping[listAdditionalServicesKey.wbaStation] = 'WBA Station';
    mapping[listAdditionalServicesKey.smallSiteModel] = 'Small Site Model';
    return mapping[key];
  }
  return null;
};

const validateEmail = function (email) {
  return new RegExp(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/).test(email);
};

const cleanArray = function (actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
};

const viewNames = {
  managerEvent: 'managerEvent',
  managerDashboard: 'managerDashboard',
  manageApprovedDashboard: 'ManageApprovedDashboard',
  staffing: 'StaffingSection',
  planAndApprove: 'PlanAndApprove',
  globalSettings: 'globalSettings',
  managerUsers: 'managerUsers'
};

const planMessage = {
  drafts: 'Create new events and submit them to ADURO for approval.',
  submitted: 'Events that have been sent to ADURO for approval.',
  review: 'Review and approve event ADURO has sent to you.',
  approved: 'Events that have been approved and scheduled.',
  archived: 'Events that have taken place are automatically moved here.'
};

const reportMessage = {
  upcoming: 'Reports based on projected participant sign ups.',
  completed: 'Reports based on event attendance.',
  satisfaction: 'Reports based on event satisfaction.'
};

const reportType = {
  upcoming: 'upcoming',
  completed: 'completed',
  satisfaction: 'satisfaction'
};

const listTime = [
  {name: '0:00 AM'},
  {name: '0:30 AM'},
  {name: '1:00 AM'},
  {name: '1:30 AM'},
  {name: '2:00 AM'},
  {name: '2:30 AM'},
  {name: '3:00 AM'},
  {name: '3:30 AM'},
  {name: '4:00 AM'},
  {name: '4:30 AM'},
  {name: '5:00 AM'},
  {name: '5:30 AM'},
  {name: '6:00 AM'},
  {name: '6:30 AM'},
  {name: '7:00 AM'},
  {name: '7:30 AM'},
  {name: '8:00 AM'},
  {name: '8:30 AM'},
  {name: '9:00 AM'},
  {name: '9:30 AM'},
  {name: '10:00 AM'},
  {name: '10:30 AM'},
  {name: '11:00 AM'},
  {name: '11:30 AM'},
  {name: '12:00 PM'},
  {name: '12:30 PM'},
  {name: '1:00 PM'},
  {name: '1:30 PM'},
  {name: '2:00 PM'},
  {name: '2:30 PM'},
  {name: '3:00 PM'},
  {name: '3:30 PM'},
  {name: '4:00 PM'},
  {name: '4:30 PM'},
  {name: '5:00 PM'},
  {name: '5:30 PM'},
  {name: '6:00 PM'},
  {name: '6:30 PM'},
  {name: '7:00 PM'},
  {name: '7:30 PM'},
  {name: '8:00 PM'},
  {name: '8:30 PM'},
  {name: '9:00 PM'},
  {name: '9:30 PM'},
  {name: '10:00 PM'},
  {name: '10:30 PM'},
  {name: '11:00 PM'},
  {name: '11:30 PM'}
];

let defaultColumnEmailHistories = [
  {
    pre: null,
    next: 'emailTemplate',
    colName: 'sentDate',
    size: 125,
    show: true
  },
  {
    colName: 'emailTemplate',
    pre: 'sentDate',
    next: 'relatedEvent',
    size: 165,
    show: true
  },
  {
    colName: 'relatedEvent',
    pre: 'emailTemplate',
    next: 'recipients',
    size: 265,
    show: true
  },
  {
    colName: 'recipients',
    pre: 'relatedEvent',
    next: 'actions',
    size: 265,
    show: true
  },
  {
    colName: 'actions',
    pre: 'recipients',
    next: null,
    size: 135,
    show: true
  }
];

const mfaType = {
  text: 'TEXT',
  email: 'EMAIL'
};

const mfaFlow = {
  init: 'INIT',
  login: 'LOGIN_TOKEN',
  disable: 'MFA_DISABLE',
  enable: 'MFA_ENABLE'
};

const googleApisMaps = 'https://maps.googleapis.com/maps/api/timezone/json';

export default {
  headerManaging: headerManaging,
  headerDropdownTextDefault: headerDropdownTextDefault,
  iconHomeForManager: iconHomeForManager,
  iconHomeForUser: iconHomeForUser,
  userRole: userRole,
  emRole: emRole,
  amRole: amRole,
  iconNames: iconNames,
  API_HOST: process.env.SOF_API_SERVER_HOST || 'http://172.24.0.47:8000',
  listOptionPrefMonth: listOptionPrefMonth,
  modalTypes: modalTypes,
  mappingModalActionToModalData: mappingModalActionToModalData,
  EVENT_TYPES: EVENT_TYPES,
  USER_ROLE: USER_ROLE,
  LOCAL_STORE: LOCAL_STORE,
  sideBarItemNames: sideBarItemNames,
  subHeaderBtn: subHeaderBtn,
  modalAction: modalAction,
  eventStatus: eventStatus,
  routeDirect: routeDirect,
  listAPI: listAPI,
  dataTableViewModes: dataTableViewModes,
  initEvent: initEvent,
  siteKey: siteKey,
  sofMessages: sofMessages,
  instructions: instructions,
  fields: fields,
  dateTimeFotmat: dateTimeFotmat,
  messageErrors: messageErrors,
  modalBodies: modalBodies,
  defaultModalMessage: defaultModalMessage,
  addOns: addOns,
  mappingKeyToTextAdditionalServices: mappingKeyToTextAdditionalServices,
  listAdditionalServicesKey: listAdditionalServicesKey,
  cleanArray: cleanArray,
  viewNames: viewNames,
  validateEmail: validateEmail,
  planMessage: planMessage,
  listTime: listTime,
  reportMessage: reportMessage,
  reportType: reportType,
  defaultColumnEmailHistories: defaultColumnEmailHistories,
  mfaFlow: mfaFlow,
  mfaType: mfaType,
  googleApisMaps: googleApisMaps
};



// WEBPACK FOOTER //
// ./src/_consts.js